<div *ngIf="data">
  <app-client-side-data-table
    [id]="'counterparties-table-id'"
    [selectFieldName]="'id'"
    [data]="data"
    [columns]="columns"
    [sort]="sort"
    [eventService]="counterpartiesListEventsService"
    [refreshIt]="refreshDataTable"
  ></app-client-side-data-table>
</div>
